export default {
    imageAIFormRules: {
        enterDescription: 'Bitte geben Sie die Beschreibung ein',
        invalidDescription: 'Bitte geben Sie eine gültige Beschreibung ein',
        enterNumberOfVariations: 'Bitte wählen Sie die Anzahl der Variationen',
        invalidNumberOfVariations: 'You can generate maximum 4 and minimum 1 variation',
        enterStyle: 'Please select at least one style',
    },
};
